import React from 'react';
import {RegulationComponentsCommon} from "../../regulation-components-common";
import {
    HeaderWelcomeRegisterButtonComponentProps
} from "../../../../components/header/buttons/register-button/header-register-button.component.props";
import {MinimumGamblingAgeComponent} from "../../../../components/responsible-gambling/minimum-gambling-age/minimum-gambling-age.component";
import {LastLoginWithSessionTimerComponent} from '../../../../components/clock-and-last-login-box/last-login-with-session-timer/last-login-with-session-timer.component';

export class MichiganRegulationComponents extends RegulationComponentsCommon {


    renderHeaderRegisterButton(props: HeaderWelcomeRegisterButtonComponentProps): React.ReactElement {
        const specificProps: Partial<HeaderWelcomeRegisterButtonComponentProps> = {};
        if(this.services.regulation.shouldEnforceHybridAppForMobileWebOnLoginAttempt()) {
            specificProps.text = this.services.translation.translate("JOIN_NOW");
        }
        return super.renderHeaderRegisterButton({
            ...props,
            ...specificProps
        });
    }

    renderHeaderMinimumGamblingAge() {
        return(<MinimumGamblingAgeComponent/>);
    }

    renderLastLoginComponent() {
        return (<LastLoginWithSessionTimerComponent />)
    }
}